









import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';

import { useDeclination } from '@/diptyqueTheme/composable/useDeclination';
import type { PostCardModel } from '~/integrations/contentful/src/types';

export default defineComponent({
  name: 'PostCard',
  components: {
    DesktopDeclination1: () => import('./declinations/desktopDeclination1.vue'),
    MobileDeclination1: () => import('./declinations/mobileDeclination1.vue')
  },
  props: {
    sectionData: {
      required: true,
      type: Object as PropType<PostCardModel>
    }
  },
  setup(props) {
    const declinationData = computed(() => props.sectionData);
    const { getDeclinationComponent, getDeclinationClass } = useDeclination(
      props.sectionData
    );

    return {
      getDeclinationComponent,
      getDeclinationClass,
      declinationData
    };
  }
});
